import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { defaultValue } from '../model/callCenterAgent.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    agents: [],
    agent: defaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
const apiUrl = 'api/call-center/agents';
// Async Actions
export const getAgents = createAsyncThunk('callCenterAgentManagement/fetch_agents', async ({ page, size, sort }) => {
    const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
    return axios.get(requestUrl);
});
export const getAgent = createAsyncThunk('callCenterAgentManagement/fetch_agent', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get(requestUrl);
}, { serializeError: serializeAxiosError });
export const createAgent = createAsyncThunk('callCenterAgentManagement/create_agent', async (agentData) => {
    const result = await axios.post(apiUrl, agentData);
    return result;
}, { serializeError: serializeAxiosError });
export const updateAgent = createAsyncThunk('callCenterAgentManagement/update_agent', async (agentData) => {
    const result = await axios.put(apiUrl, agentData);
    return result;
}, { serializeError: serializeAxiosError });
export const deleteAgent = createAsyncThunk('callCenterAgentManagement/delete_agent', async (id) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete(requestUrl);
    return result;
}, { serializeError: serializeAxiosError });
export const CallCenterAgentManagementSlice = createSlice({
    name: 'callCenterAgentManagement',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getAgent.fulfilled, (state, action) => {
            state.loading = false;
            state.agent = action.payload.data;
        })
            .addCase(deleteAgent.fulfilled, state => {
            state.updating = false;
            state.updateSuccess = true;
            state.agent = defaultValue;
        })
            .addMatcher(isFulfilled(getAgents), (state, action) => {
            state.loading = false;
            state.agents = action.payload.data;
            state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
        })
            .addMatcher(isFulfilled(createAgent, updateAgent), (state, action) => {
            state.updating = false;
            state.loading = false;
            state.updateSuccess = true;
            state.agent = action.payload.data;
        })
            .addMatcher(isPending(getAgents, getAgent), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.loading = true;
        })
            .addMatcher(isPending(createAgent, updateAgent, deleteAgent), state => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.updating = true;
        })
            .addMatcher(isRejected(getAgents, getAgent, createAgent, updateAgent, deleteAgent), (state, action) => {
            state.loading = false;
            state.updating = false;
            state.updateSuccess = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = CallCenterAgentManagementSlice.actions;
// Reducer
export default CallCenterAgentManagementSlice.reducer;
